module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2022@2x.702d66fa.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2022@2x.png
// module id = 1156
// module chunks = 0